import axios from 'axios';
import VoGenerator from './VoGenerator';
import {MomentToDateTime} from './MomentDateTimeConverter';
import {message} from 'antd';
import qs from 'qs';
import {shaEncrypt} from './EncodeDecodeMethod';

export const GetApiMethod = ({getApi, setDataSource, setCopyDataSource}) => {
	const orgId = (parseInt(sessionStorage.getItem('coffee')) / 20).toString();
	RealtimeGetMethod(getApi).then(savedResult => {
		savedResult = savedResult?.length > 0 ? savedResult : [];
		// console.log('列表数据:    ', savedResult);
		// 根据 organization_id 对数据进行过滤，考虑到联合查表得到的为 snake 形式，管理员可以看到全部，会议通知里没有 orgId 需要考虑
		if (orgId !== '1000') {
			savedResult = savedResult?.filter(item => {
				if (item.organizationId || item.organization_id) {
					return item.organizationId === orgId || item.organization_id === orgId;
				} else {
					return true;
				}
			});
		}
		setDataSource(savedResult);
		setCopyDataSource(savedResult);
	});
};

export const GetOrgData = (getApi) => {
	const orgId = (parseInt(sessionStorage.getItem('coffee')) / 20).toString();
	return RealtimeGetMethod(getApi).then(resultList => {
		// console.log("表单数据:    ", resultList);
		const filterData = resultList?.length > 0 ?
			resultList.filter(item => item.organizationId === orgId) : [];
		return filterData?.length > 0 ? filterData[0] : {};
	});
};

export const RealtimeGetMethod = (getApi) => {
	const config = {
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded',
			'Authorization': `${generateToken()}`,
			'Token': sessionStorage.getItem('userToken'),
		},
	};
	return axios.get(getApi, config).then(res => {
		if (res) {
			if (res.data.code === 1 || res.data.code === '1') {
				// console.log('表单数据:    ', res.data);
				const resultList = res.data.result.data.resultList;
				return resultList?.length > 0 ? resultList.filter(item => item.state === 1) : [];
			}
		} else {
			// console.log("数据返回异常");
			return [];
		}
	}).catch(error => {
		// console.log("接口请求异常: ", error)
	});
};

// data 为字典形式（对象类型），如 {username: "li", password: "111"}， postUrl 为字符串形式
export const PostApiMethod = (postUrl, data) => {
	if (Object.keys(data).length > 0) {
		const ObjData = convertData(data);
		// console.log("ObjData", ObjData)
		PostToJava(postUrl, ObjData).then(res => {
			if (res) {
				if (res.data.code === 1 || res.data.code === '1') {
					// console.log("操作成功");
					// 在前端只显示一条 message，即最后一条
					if (!ObjData['ovo.dataIndex'] || ObjData['ovo.dataIndex'] === 1) {
						message.success('操作成功');
					}
				} else {
					// console.log("当前数据保存失败：" + res)
					message.error('数据提交失败');
				}
			} else {
				// console.log("数据返回异常");
			}
		});
	} else {
		message.warning('数据为空');
	}
};

export const convertData = (data) => {
	if (Object.keys(data).length > 0) {
		// 将提交的 data 中属于 Moment 类型数据转成 DateTime 类型，保存到数据库中
		const newData = MomentToDateTime(data);
		// 将 data 中的 key 转成 ovo.key 的形式
		return VoGenerator(newData);
	} else {
		return {};
	}
};

// 注意 ObjData 中的日期为 Moment 类型，如果不是表单提交上来的数据，需要使用 DateTimeToMoment(ObjData) 进行转换
// 如果是向数据库中新增数据，应使用 PostApiMethod 方法
export const PostToJava = (postUrl, ObjData) => {
	const config = {
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded',
			'Authorization': `${generateToken()}`,
			'Token': sessionStorage.getItem('userToken'),
		},
	};

	const sysLogInfo = {moduleName: sessionStorage.getItem('moduleName'), ip: sessionStorage.getItem('ip')};
	// 如果要将 axios POST 请求的请求体格式设置为  application/x-www-form-urlencoded ，可以使用 qs 库将数据格式化为 URL 编码的形式。
	// 这样在 java 后端中就可以使用 String username = request.getParameter("username"); 获取传递的参数了
	return axios.post(postUrl, qs.stringify({...ObjData, ...sysLogInfo}), config).then(res => res).catch(err => {
		// console.log("程序异常：", err);
		message.error('数据提交失败');
	});
};

export const PostImage = (postUrl, file) => {
	const formData = new FormData();
	formData.append('uploadedImage', file);
	const config = {
		headers: {
			'Accept': 'image/*',
			'Content-Type': 'multipart/form-data',
			'Authorization': `${generateToken()}`,
			'Token': sessionStorage.getItem('userToken'),
		},
	};
	// 使用 axios POST 向服务器上传文件，将请求体格式设置为 multipart/form-data，并将 file 放入 formData，
	// 此时的 key(uploadedImage) 应与 Java 后端中的参数 List<StrutsXFile> uploadedImage 一致。
	return axios.post(postUrl, formData, config).then(res => res).catch(err => {
		// console.log("程序异常：", err);
		message.error('程序异常');
	});
};

export const getIPAddress = () => {
	return axios.get('https://api.ipify.org?format=json').then(res => {
		const {ip} = res?.data;
		return ip || 'can\'t get ip';
	});
};

export function generateToken() {
	const timestamp = Math.floor(Date.now() / (1000 * 60));
	const secret = 'n0&9%3K,O0#h*j0u-^';
	const salt = 79824302;
	const token = `${timestamp}:${secret}:${salt}`;
	return shaEncrypt(token); // 使用sha256加密算法对token进行加密
}